import { Component, Inject, OnInit } from '@angular/core';
import { DialogRef, DIALOG_DATA } from '@icc/ui';

export interface ComplaintMapDialogData {
    initialPosition?: google.maps.LatLngLiteral;
}

@Component({
    selector: 'icc-complaint-map-dialog',
    templateUrl: './complaint-map-dialog.component.html',
    styleUrls: ['./complaint-map-dialog.component.scss'],
})
export class ComplaintMapDialogComponent implements OnInit {
    markerPosition: google.maps.LatLngLiteral | null = null;
    mapZoom: number = 15;
    geocodedAddress: string = '';

    constructor(
        @Inject(DIALOG_DATA) public data: ComplaintMapDialogData,
        private dialogRef: DialogRef,
    ) {
        if (data.initialPosition) {
            this.markerPosition = data.initialPosition;
        } else {
            this.markerPosition = {
                lat: 52.0693,
                lng: 19.4803,
            };
            this.mapZoom = 6;
        }
    }

    ngOnInit(): void {
    }

    cancel(): void {
        this.dialogRef.close();
    }
}
